export default __webpack_public_path__ + "static/media/implementacion.0b329e95.png";